import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
		menuStatus:false
	},
  mutations: {
	 SET_MENU_STATUS:(state, menuStatus) => {
					state.menuStatus = menuStatus
			}
	},
  actions: {
		  toggleMenuStatus({commit},menuStatus){
		    commit("SET_MENU_STATUS",menuStatus)
	   }
	},
	getters: {
       menuStatus:state => {return state.menuStatus},
   }
});
